import { Nullish } from "@becon-team/becon-fe-lib/my-types";

enum PathParamsEnum {
  articleId = ":articleId",
  setId = ":setId",
  analysisId = ":analysisId",
  jobId = ":jobId",
  email = ":email",
  accessToken = ":accessToken",
}

/**
 * 주어진 경로에서 하위 <Route>의 경로를 생성하는 함수
 * @param path 경로 문자열
 * @param number 제외할 경로 세그먼트의 수 (기본값 1)
 * @returns 지정된 수의 경로 세그먼트를 제외한 나머지 경로 문자열
 */
export const getTailOfPath = (path: string, number = 1): string => {
  const pathArray = path.split("/");
  const tailPath = pathArray.slice(number).join("/") || "";

  return `${tailPath}`;
};

export const path = {
  // --- community --- //

  community: () => "/community",
  writeArticle: () => `${path.community()}/write`,
  editArticle: (articleId: Nullish<string>) => `${path.community()}/edit/${articleId ?? PathParamsEnum.articleId}`,
  detailArticle: (articleId: Nullish<string>) => `${path.community()}/${articleId ?? PathParamsEnum.articleId}`,
  // --- analysis --- //
  analysis: () => "/analysis",

  // --- scalp --- //
  scalp: () => `/scalp`,
  scalpAnalysis: () => `/analysis`,
  scalpMicro: () => path.scalp() + "/micro",
  scalpMicroAnalysis: () => path.scalpMicro() + "/analysis",
  scalpResult: (setId: Nullish<string>) => `${path.scalp()}/result/${setId ?? PathParamsEnum.setId}`,
  scalpResultPolling: (jobId: Nullish<string>) => `${path.scalp()}/result/polling/${jobId ?? PathParamsEnum.jobId}`,
  scalpDummyResult: (setId: Nullish<string>) => `${path.scalp()}/result/dummy/${setId ?? PathParamsEnum.setId}`,

  // --- skin --- //

  skin: () => "/skin",
  skinMacro: () => `${path.skin()}/macro`,
  skinMacroInquiry: () => path.skinMacro() + "/inquiry",
  skinMacroResult: (setId: Nullish<string>) => `${path.skinMacro()}/result/${setId ?? PathParamsEnum.setId}`,
  skinMicro: () => `${path.skin()}/micro`,
  skinMicroAnalysis: () => path.skinMicro() + "/analysis",
  skinMicroResult: (setId: Nullish<string>) => `${path.skinMicro()}/result/${setId ?? PathParamsEnum.setId}`,
  skinMicroDummyResult: (setId: Nullish<string>) => `${path.skinMicro()}/result/dummy/${setId ?? PathParamsEnum.setId}`,

  // --- crown --- //

  crown: () => "/crown",
  crownResult: (analysisId: Nullish<string>) => `${path.crown()}/result/${analysisId ?? PathParamsEnum.analysisId}`,

  // --- forehead --- //

  forehead: () => "/forehead",
  foreheadResult: (analysisId: Nullish<string>) =>
    `${path.forehead()}/result/${analysisId ?? PathParamsEnum.analysisId}`,
  foreheadSimulation: (analysisId: Nullish<string>) =>
    `${path.forehead()}/simulation/${analysisId ?? PathParamsEnum.analysisId}`,

  // --- history --- //
  history: () => "/history",
  // b2b history
  historyB2B: () => path.history() + "/b2b/list",
  // skin history
  macroSkinHistory: () => path.history() + "/macro-skin",
  macroSkinHistoryTrend: () => path.macroSkinHistory() + "/trend",
  macroSkinHistoryList: () => path.macroSkinHistory() + "/list",

  microSkinHistory: () => path.history() + "/micro-skin",
  microSkinHistoryTrend: () => path.microSkinHistory() + "/trend",
  microSkinHistoryList: () => path.microSkinHistory() + "/list",

  // crown history
  crownHistoryList: () => path.history() + "/crown" + "/list",

  // forehead history
  foreheadHistoryList: () => path.history() + "/forehead" + "/list",

  // scalp history
  scalpHistory: () => path.history() + "/scalp",
  scalpHistoryList: () => path.scalpHistory() + "/list",
  scalpHistoryTrend: () => path.scalpHistory() + "/trend",

  // shampoo
  shampoo: () => "/shampoo",

  // partnership
  partnership: () => "/partnership",

  // weather
  weather: () => "/weather",

  // big data
  bigData: () => "/big-data",

  // auth
  auth: () => "/auth",
  authLogin: (email: Nullish<string>) => `${path.auth()}/login/${email ?? PathParamsEnum.email}`,
  authKakao: (accessToken: Nullish<string>) => `${path.auth()}/kakao/${accessToken ?? PathParamsEnum.accessToken}`,
  authForgotEmail: () => `${path.auth()}/forgot-email`,
  authForgotPassword: () => `${path.auth()}/forgot-password`,
  authSignup: () => `${path.auth()}/signup`,
} as const;
